import { render, staticRenderFns } from "./add_column.vue?vue&type=template&id=77a457b4&scoped=true&"
import script from "./add_column.vue?vue&type=script&lang=js&"
export * from "./add_column.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./add_column.vue?vue&type=style&index=1&id=77a457b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a457b4",
  null
  
)

export default component.exports